/**
 * Frontend Cache Helper (Mimics Redis behavior in the browser)
 * Used to cache dropdown options and date-range specific data.
 */
const CACHE_PREFIX = 'frontend_cache:';
export const getCache = (key) => {
    try {
        const fullKey = CACHE_PREFIX + key;
        const cached = sessionStorage.getItem(fullKey);
        if (!cached)
            return null;
        const { value, expiry } = JSON.parse(cached);
        if (expiry && Date.now() > expiry) {
            sessionStorage.removeItem(fullKey);
            return null;
        }
        return value;
    }
    catch (e) {
        return null;
    }
};
export const setCache = (key, value, ttlSeconds = 3600) => {
    try {
        const fullKey = CACHE_PREFIX + key;
        const expiry = Date.now() + ttlSeconds * 1000;
        sessionStorage.setItem(fullKey, JSON.stringify({ value, expiry }));
    }
    catch (e) {
        // Fail silently
    }
};
export const generateCacheKey = (prefix, params) => {
    const sortedParams = Object.keys(params || {})
        .sort()
        .reduce((acc, key) => {
        acc[key] = params[key];
        return acc;
    }, {});
    return `${prefix}:${JSON.stringify(sortedParams)}`;
};
export const clearCache = (prefix) => {
    if (prefix) {
        const fullPrefix = CACHE_PREFIX + prefix;
        Object.keys(sessionStorage).forEach(key => {
            if (key.startsWith(fullPrefix)) {
                sessionStorage.removeItem(key);
            }
        });
    }
    else {
        Object.keys(sessionStorage).forEach(key => {
            if (key.startsWith(CACHE_PREFIX)) {
                sessionStorage.removeItem(key);
            }
        });
    }
};
